import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from 'components/UI/V3/Chip/Chip.module.scss';
import React from 'react';

interface ChipProps {
    icon?: IconProp;
    label: string;
}

export const Chip: React.FC<ChipProps> = ({ icon, label }) => {
    return (
        <div className={styles.root}>
            {icon && <FontAwesomeIcon icon={icon} />}
            <span className={styles.label}>{label}</span>
        </div>
    );
};
